/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBag = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 2a1 1 0 0 1 .8.4l3 4 .02.027a1 1 0 0 1 .042.066L21.8 6.4a1.004 1.004 0 0 1 .2.58V21a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6.989l.002-.057L2 7a1.01 1.01 0 0 1 .073-.375l.008-.019a.9.9 0 0 1 .044-.09l.012-.022a.912.912 0 0 1 .051-.079L2.2 6.4l3-4A1 1 0 0 1 6 2zm2 6H4v12h16zM9 10c0 1.654 1.346 3 3 3s3-1.346 3-3h2c0 2.757-2.243 5-5 5s-5-2.243-5-5zm8.5-6h-11L5 6h14z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBag as Bag };
